import { register } from "@shopify/theme-sections";
import $ from "jquery";

let defaults = {
	activeClass: "active",
	accordionClass: "simple-accordion",
	accordionTitleClass: "simple-accordion__title"
};

let selectors = {
	accordion: "[data-simple-accordion]",
	title: `.${defaults.accordionTitleClass}`
};

register("dropdown-menu", {
	onLoad: function () {
		let $accordions = $(selectors.accordion);
		if (!$accordions.length) {
			return;
		}

		this.initAccordion($accordions);
	},

	openClose: function (event) {
		const self = event.target;
		let activeTitle = $(this).closest(`.${defaults.accordionTitleClass}`);
		self.$titles = activeTitle;
		let $currentTitle = $(this);
		let $target = activeTitle.next();
		let $active = self.$titles.filter(`.${defaults.activeClass}`).next();

		let close = false;
		if ($target[0] == $active[0]) {
			close = true;
		}

		event.preventDefault();

		self.$titles.removeClass(defaults.activeClass);

		let height = {
			target: {},
			active: {}
		};

		height.target.current = $target.height();
		height.active.new = 0;
		height.active.current = $active.height();

		$active.height(height.active.current);

		if (!close) {
			$(this).addClass(defaults.activeClass);
			$target.height(height.target.current);
			$target.addClass(defaults.activeClass);
		}

		$active.removeClass(defaults.activeClass);

		$target.height("auto");
		$active.height("auto");
		$active.height(height.active.new);
		height.target.new = $target.get(0).scrollHeight;
		$target.offset();
		$active.offset();
		$currentTitle.trigger("accordionTransitionHeightCalc");
		$active.height("auto");
		$active.height(height.active.current);
		$target.height(height.target.current);
		$target.height(height.target.new);

		$active.height(height.active.new);

		setTimeout(function () {
			$target.height("");
			$active.height("");
			$currentTitle.trigger("accordionTransitionEnd");
		}, 500);

		return;
	},
	initAccordion(el) {
		this.$el = $(el);
		this.$titles = this.$el.find(selectors.title);
		if (!this.$titles.length) {
			this.$titles = this.$el.children().first();
			this.$titles.addClass(defaults.accordionTitleClass);
		}

		let self = this;
		self.$el.addClass(defaults.accordionClass);

		self.$titles.on("click.accordion", this.openClose);
	}
});
